:host {
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 15px;
}
